module.exports = __webpack_public_path__ + "static/img/banner_new.b823985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_new.png
// module id = qPtm
// module chunks = 1